import './App.css';
import Meja from './Meja.js';

export default function App() {
  return (
    <div className="App" >
      <p className='text-2xl font-bold p-3'>
  <span>my</span>
  <span className='text-yellow-500'>honours</span>
  <span > (2022)</span>
</p>
      <Meja/>
    </div>
  );
}

